import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AccountCircle } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';

const AddTeamMember = () => {
  const [profilePic, setProfilePic] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [designation, setDesignation] = useState('');
  const [category, setCategory] = useState('');
  const [onlineStatus, setOnlineStatus] = useState('active');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        setProfilePic(file);
        setError(null);
      } else {
        setError('Please select a valid image file (e.g., JPEG, PNG).');
        setProfilePic(null);
      }
    }
  };

  const addTeamMember = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    dispatch({ type: 'LOADING' });

    // Basic validation
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError('Please enter a valid email address.');
      setLoading(false);
      dispatch({ type: 'DONE_LOADING' });
      return;
    }
    if (!phone.match(/^\d{10,15}$/)) {
      setError('Please enter a valid phone number (10-15 digits).');
      setLoading(false);
      dispatch({ type: 'DONE_LOADING' });
      return;
    }

    const data = new FormData();
    if (profilePic) {
      data.append('profile_pic', profilePic);
    }
    data.append('first_name', firstName);
    data.append('last_name', lastName);
    data.append('email', email);
    data.append('phone', phone);
    data.append('designation', designation);
    data.append('category', category);
    data.append('status', onlineStatus);

    try {
      const res = await axios.post(ENDPOINT + 'add-team-member.php', data, SecurityHeaders);

      if (res?.data?.status === 'success') {
        dispatch({ type: 'DONE_LOADING' });
        window.location.replace('/team-members-all');
      } else {
        dispatch({
          type: 'ERROR',
          payload: res?.data?.message || 'Failed to add team member',
        });
        setError(res?.data?.message || 'Failed to add team member');
      }
    } catch (error) {
      dispatch({
        type: 'ERROR',
        payload: error.message || 'An error occurred while adding team member',
      });
      setError(error.message || 'An error occurred while adding team member');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="container card col-11 col-lg-6 col-sm-12 col-md-10 p-4 shadow rounded-3">
        <h2 className="mb-3">Add Team Member</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        {loading && <div className="text-center mb-3"><div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div></div>}
        <form onSubmit={addTeamMember}>
          <div className="mb-3">
            <label htmlFor="profilePic" className="form-label">Profile Picture</label>
            <div>
              <div
                style={{
                  height: 90,
                  width: 90,
                  borderRadius: '50%',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  display: 'inline-block',
                  backgroundColor: '#f0f0f0',
                  backgroundImage: profilePic ? `url(${URL.createObjectURL(profilePic)})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                {!profilePic && (
                  <AccountCircle style={{ height: '100%', width: '100%', color: '#ccc' }} />
                )}
              </div>
              <input
                type="file"
                id="profilePic"
                accept="image/*"
                onChange={handleFileChange}
                className="form-control mt-2"
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="firstName" className="form-label">First Name</label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="lastName" className="form-label">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">Phone Number</label>
            <input
              type="text"
              className="form-control"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="designation" className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              id="designation"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="category" className="form-label">Category</label>
            <input
              type="text"
              className="form-control"
              id="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="onlineStatus" className="form-label">Online Status</label>
            <select
              className="form-control"
              id="onlineStatus"
              value={onlineStatus}
              onChange={(e) => setOnlineStatus(e.target.value)}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Adding...' : 'Add Team Member'}
          </button>
          <Link to="/team-members-all" className="btn btn-secondary ms-2">
            Cancel
          </Link>
        </form>
      </div>
    </div>
  );
};

export default AddTeamMember;